import React from "react";
import Game from "../game/Game";

export default function App() {
  return (
    <Game />
  );
}
